import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { bip32asBuffer } from "./bip32";
/**
 * address format is one of legacy | p2sh | bech32 | cashaddr
 */

var addressFormatMap = {
  legacy: 0,
  p2sh: 1,
  bech32: 2,
  cashaddr: 3
};
export function getWalletPublicKey(_x, _x2) {
  return _getWalletPublicKey.apply(this, arguments);
}

function _getWalletPublicKey() {
  _getWalletPublicKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transport, options) {
    var _verify$format$option, path, verify, format, buffer, p1, p2, response, publicKeyLength, addressLength, publicKey, bitcoinAddress, chainCode;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _verify$format$option = _objectSpread({
              verify: false,
              format: "legacy"
            }, options), path = _verify$format$option.path, verify = _verify$format$option.verify, format = _verify$format$option.format;

            if (format in addressFormatMap) {
              _context.next = 3;
              break;
            }

            throw new Error("btc.getWalletPublicKey invalid format=" + format);

          case 3:
            buffer = bip32asBuffer(path);
            p1 = verify ? 1 : 0;
            p2 = addressFormatMap[format];
            _context.next = 8;
            return transport.send(0xe0, 0x40, p1, p2, buffer);

          case 8:
            response = _context.sent;
            publicKeyLength = response[0];
            addressLength = response[1 + publicKeyLength];
            publicKey = response.slice(1, 1 + publicKeyLength).toString("hex");
            bitcoinAddress = response.slice(1 + publicKeyLength + 1, 1 + publicKeyLength + 1 + addressLength).toString("ascii");
            chainCode = response.slice(1 + publicKeyLength + 1 + addressLength, 1 + publicKeyLength + 1 + addressLength + 32).toString("hex");
            return _context.abrupt("return", {
              publicKey: publicKey,
              bitcoinAddress: bitcoinAddress,
              chainCode: chainCode
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getWalletPublicKey.apply(this, arguments);
}